import React, { Component } from "react";
import Constants from "../constants";
import { FormGroup, Label, Input } from "reactstrap";

import "../App.css";

class ContourLayerWidget extends Component {
  render() {
    const { setContoursVisible, getContoursVisible } = this.props;

    return (
      <div className="radio-buttons contours-layer-widget">
        <p>
          <strong>{Constants.contourLayerWidgetTitle}</strong>
        </p>
        <FormGroup
          onChange={e => {
            setContoursVisible(!getContoursVisible);
          }}
        >
          <Label check>
            <Input
              type="radio"
              name={"contour-layer-radio"}
              value={true}
              checked={getContoursVisible}
              readOnly
            />
            Show Contours
          </Label>
          <Label check>
            <Input
              type="radio"
              name={"contour-layer-radio"}
              value={false}
              checked={getContoursVisible === false}
              readOnly
            />
            Hide Contours
          </Label>
        </FormGroup>
      </div>
    );
  }
}

export default ContourLayerWidget;
